import dayjs from 'dayjs';

/** Fields cleared when cloning so a new venue can drive autopopulated config. */
const VENUE_DEPENDENT_CLEAR: Record<string, unknown> = {
  venue: '',
  layout: '',
  layoutObj: '',
  pricePackage: '',
  pricePackageId: null,
  pricePackageObj: null,
  customPricePackageName: '',
  serviceCharge: null,
  serviceChargePercentage: '',
  taxGroupOnGuestCharge: '',
  taxGroupOnHallRental: '',
  addOns: [],
  minimumRevenue: '',
  pricePerHour: '',
  totalRental: '',
  preLeadTime: '',
  postLeadTime: '',
  pricePerPerson: '',
  lineItemTotal: null,
  lineItemTotalUnformatted: null,
};

/** Copy event-level line fields; venue and venue-driven values stay empty until user picks a venue. */
export function buildClonedLineItemDrawerState(source: Record<string, any>) {
  const base = JSON.parse(JSON.stringify(source)) as Record<string, any>;
  const merged = { ...base, ...VENUE_DEPENDENT_CLEAR };
  merged.startTime = dayjs(String(source.startTime || ''), 'HH:mm');
  merged.endTime = dayjs(String(source.endTime || ''), 'HH:mm');
  return merged;
}
